import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { Box, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Building, ClipboardExport, DocumentText, More2, Timer1 } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
import { UserDetailDialog } from '../dialog/UserDetailDialog';
import { TableHeader } from '../../../../../components/common/header/tableHeader/TableHeader';
import { SecondaryGrid } from '../../../../../components/common/grid/SecondaryGrid';
import { colCenter } from '../../../../../style/style';
import { CustomChip } from '../../../../../components/common/chip/Chip';
import { useAppSelector } from '@application/store/useStore';
import { UserStatusMap } from '@application/common/enums/user-status';
import { ClientContractStatusMapForFreelancer } from '@application/common/enums/client-contract-status';
export const UserTable = ({ searchQuery }) => {
    const theme = useTheme();
    const isMd = useMediaQuery('(min-width: 1225px) and (max-width: 1611px)');
    const isSm = useMediaQuery('(min-width: 368px) and (max-width: 1224px)');
    const { users } = useAppSelector((state) => state.user);
    const navigate = useNavigate();
    const [userDialog, setUserDialog] = useState(false);
    const columns = [
        {
            field: 'name',
            headerName: 'Name',
            minWidth: isSm ? 150 : isMd ? 210 : undefined,
            flex: isMd ? undefined : 1,
            renderHeader: () => _jsx(TableHeader, { icon: Building, text: 'Name' })
        },
        {
            field: 'position',
            headerName: 'Position',
            minWidth: isSm ? 200 : isMd ? 210 : undefined,
            flex: isMd ? undefined : 1,
            renderHeader: () => _jsx(TableHeader, { icon: DocumentText, text: 'Position' })
        },
        {
            field: 'client',
            headerName: 'Client',
            minWidth: isSm ? 150 : isMd ? 140 : undefined,
            flex: isMd ? undefined : 1,
            renderHeader: () => _jsx(TableHeader, { icon: Timer1, text: 'Active Client' })
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: isSm ? 150 : isMd ? 130 : undefined,
            flex: isMd ? undefined : 1,
            renderHeader: () => _jsx(TableHeader, { icon: More2, text: 'Status' }),
            renderCell: (params) => {
                return _jsx(CustomChip, { value: UserStatusMap.get(params.value) });
            }
        },
        {
            field: 'processAction',
            headerName: 'Process',
            minWidth: isSm ? 150 : isMd ? 150 : undefined,
            flex: isMd ? undefined : 1,
            renderHeader: () => _jsx(TableHeader, { icon: More2, text: 'Process' }),
            renderCell: (params) => {
                if (params && params.row && params.row.processAction === 0) {
                    return _jsx(_Fragment, { children: "Assign Client" });
                }
                return _jsx(_Fragment, { children: ClientContractStatusMapForFreelancer.get(params.value) });
            }
        },
        {
            field: 'actions',
            headerName: 'Actions',
            headerAlign: 'center',
            align: 'center',
            minWidth: isSm ? 120 : isMd ? 120 : undefined,
            flex: isMd ? undefined : 1,
            renderHeader: (params) => (_jsxs(Box, { sx: { ...colCenter, gap: 2 }, children: [_jsx(ClipboardExport, { style: { color: theme.palette.primary.main } }), _jsx(Typography, { variant: 'subtitle2', color: 'white', children: "Actions" })] })),
            renderCell: (params) => {
                const id = params.row.id;
                return (_jsx(IconButton, { onClick: () => navigate(`/users-edit-user?${new URLSearchParams({ id }).toString()}`), children: _jsx(ClipboardExport, {}) }));
            }
        }
    ];
    const filteredRows = useMemo(() => {
        return (users?.items || []).filter((user) => {
            const processActionText = ClientContractStatusMapForFreelancer.get(user?.processAction) || 'Assign Client';
            return (user?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                user?.client?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                user?.position?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                processActionText.toLowerCase().includes(searchQuery.toLowerCase()) ||
                UserStatusMap.get(user?.status)?.toLowerCase().includes(searchQuery.toLowerCase()));
        });
    }, [searchQuery, users]);
    return (_jsxs("div", { children: [_jsx(SecondaryGrid, { columns: columns, rows: filteredRows }), _jsx(UserDetailDialog, { handleClose: () => setUserDialog(false), open: userDialog })] }));
};
